<template>
    <div class="draggable-item-menu-options">
        <div class="draggable-item-menu-btn-container" v-if="atLeastOneMenuOptionVisible">
            <ViewOrderReferenceButton 
                v-if="viewOptionVisible"
                :orderReferenceId="orderReference.id"
            />
            <SplitOrderReferenceButton 
                v-if="splitOptionVisible"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
            />
            <MergeOrderReferenceButton
                v-if="mergeOptionVisible"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
            />
            <StartOrderReferenceButton 
                v-if="startOptionVisible"
                :orderReferenceId="orderReference.id"
                :endOfAction="endOfAction"
            />
            <FinishOrderReferenceButton 
                v-if="finishOptionVisible"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
            />
            <PauseOrderReferenceButton 
                v-if="pauseOptionVisible"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
            />
            <DeleteStockOrderReferenceButton 
                v-if="deleteOptionVisible"
                :orderReferenceId="orderReference.id"
                :endOfAction="endOfAction"
            />
        </div>
        <div class="draggable-item-options-container" v-else>
            {{ noOptionsMessage }}
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PermissionsConsts from "../../../../common/permissions";
import ViewOrderReferenceButton from "./ViewOrderReferenceButton/ViewOrderReferenceButton.vue";
import StartOrderReferenceButton from "./StartOrderReferenceButton/StartOrderReferenceButton.vue";
import FinishOrderReferenceButton from "./FinishOrderReferenceButton/FinishOrderReferenceButton.vue";
import PauseOrderReferenceButton from "./PauseOrderReferenceButton/PauseOrderReferenceButton.vue";
import SplitOrderReferenceButton from "./SplitOrderReferenceButton/SplitOrderReferenceButton.vue";
import MergeOrderReferenceButton from "./MergeOrderReferenceButton/MergeOrderReferenceButton.vue";
import DeleteStockOrderReferenceButton from "./DeleteStockOrderReferenceButton/DeleteStockOrderReferenceButton.vue";
export default {
    name: "ProductionOrderCardMenuOptions",
    components: {
        ViewOrderReferenceButton,
        StartOrderReferenceButton,
        FinishOrderReferenceButton,
        PauseOrderReferenceButton,
        SplitOrderReferenceButton,
        MergeOrderReferenceButton,
        DeleteStockOrderReferenceButton
    },
    props: {
        orderReference: {
            type: Object,
            required: true
        },
        emitCloseMenu: {
            type: Function,
            required: true
        },
        isThereOrInProductionAtProductionLine: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        ...mapActions('production_control', ['setShowKanbanContainerOverlay']),
        endOfAction() {
            this.emitCloseMenu();
            this.setShowKanbanContainerOverlay(true);
        },
    },
    computed: {
        ...mapGetters('production_control', ['queueEditActive']),
        ...mapGetters(['userPermissions', 'userHasPermission']),
        canViewOrderReference() {
            return this.userHasPermission(PermissionsConsts.ORDER_REFERENCE_VIEW);
        },
        canSplitOrderReference() {
            return this.userHasPermission(PermissionsConsts.PLANNER_ORDER_REFERENCE_SPLIT);
        },
        canMergeOrderReference() {
            return this.userHasPermission(PermissionsConsts.PLANNER_ORDER_REFERENCE_MERGE);
        },
        canProgressOrderReference() {
            return this.userHasPermission(PermissionsConsts.PLANNER_PRODUCTION_LINE_PROGRESS_ORDER);
        },
        canPauseOrderReference() {
            return this.userHasPermission(PermissionsConsts.PLANNER_ORDER_REFERENCE_IS_PAUSE_POSSIBLE_GET);
        },
        canDeleteStockOrderReference() {
            return this.userHasPermission(PermissionsConsts.STOCK_ORDER_REFERENCE_DELETE);
        },
        isPending() {
            return this.orderReference.order_state_id == 1;
        },
        isProducing() {
            return this.orderReference.order_state_id == 2;
        },
        isProduced() {
            return this.orderReference.order_state_id == 3;
        },
        isProducedOrProducing() {
            return this.orderReference.order_state_id == 2 || this.orderReference.order_state_id == 3
        },
        hasCopies() {
            return (this.orderReference.divisions && this.orderReference.divisions.filter(copy => copy.id !== this.orderReference.id && copy.order_state_id === 1).length > 0);
        },
        isStockOrderReference() {
            return this.orderReference.order.is_stock_order;
        },
        viewOptionVisible() {
            return this.isProducedOrProducing && this.canViewOrderReference;
        },
        mergeOptionVisible() {
            return this.isPending && this.hasCopies && !this.queueEditActive && this.canMergeOrderReference;
        },
        splitOptionVisible() {
            return this.isPending && !this.queueEditActive && this.canSplitOrderReference;
        },
        startOptionVisible() {
            return this.isPending && !this.queueEditActive && this.canProgressOrderReference && !this.isThereOrInProductionAtProductionLine && this.orderReference.is_or_next_in_queue;
        },
        finishOptionVisible() {
            return this.isProducing && !this.queueEditActive && this.canProgressOrderReference;
        },
        pauseOptionVisible() {
            return this.isProducing && !this.queueEditActive && this.canPauseOrderReference;
        },
        deleteOptionVisible() {
            return this.isPending && !this.queueEditActive && this.canDeleteStockOrderReference && this.isStockOrderReference;
        },
        atLeastOneMenuOptionVisible() {
            return this.viewOptionVisible || this.mergeOptionVisible || this.splitOptionVisible || this.startOptionVisible || this.finishOptionVisible || this.pauseOptionVisible || this.deleteOptionVisible;
        },
        noOptionsMessage() {
            let message = this.queueEditActive
                ? 'No se pueden realizar acciones en modo edición de cola'
                : 'No hay opciones disponibles para esta tarjeta';
            return message;
        },
    },
};
</script>